import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { X } from "lucide-react";

export function ManageTeamModal({ open, onClose, responsaveis, newName, setNewName, onAdd, onRemove }) {
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-xs">
        <DialogHeader>
          <DialogTitle className="text-zinc-100 text-base font-semibold">Equipe</DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          <div className="flex gap-2">
            <Input
              data-testid="new-resp-input"
              value={newName}
              onChange={(e) => setNewName(e.target.value)}
              placeholder="Nome do responsavel"
              className="h-8 text-xs flex-1"
              onKeyDown={(e) => e.key === "Enter" && onAdd()}
            />
            <Button
              data-testid="new-resp-save-btn"
              onClick={onAdd}
              disabled={!newName.trim()}
              className="bg-amber-500 text-zinc-950 hover:bg-amber-600 h-8 text-xs font-semibold disabled:opacity-30"
            >
              Adicionar
            </Button>
          </div>

          {responsaveis.length > 0 && (
            <div className="pt-2 border-t border-zinc-800">
              <p className="text-[10px] text-zinc-600 mb-2 uppercase tracking-wider font-semibold">Ativos</p>
              <div className="space-y-1">
                {responsaveis.map((r) => (
                  <div
                    key={r}
                    className="flex items-center justify-between px-3 py-2 rounded-md bg-zinc-900 group"
                  >
                    <span className="text-sm text-zinc-300">{r}</span>
                    <button
                      onClick={() => onRemove(r)}
                      className="opacity-0 group-hover:opacity-100 text-zinc-600 hover:text-red-400 transition-all duration-200"
                    >
                      <X className="h-3.5 w-3.5" />
                    </button>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
